(function () {
    'use strict';

    function main() {
        var page = wo$('#share-tablet');
        if (!page.length) return;
        var data = WhistleOut.readLookupData(page);

        var controller = {
            init: function () {
                page.find('#embed-code, #share-url')
                    .off('click')
                    .click(function () {
                        WhistleOut.focusAndSelect(this, true);
                        WhistleOut.triggerPopoverNotification(this, data.resources.copied, 'bottom');
                    });

                page.on('show.bs.modal', function () {
                    var url = WhistleOut.replaceQueryString(data.embedInfoUrl, location.search);
                    wo$.ajax({
                        type: 'GET',
                        url: url,
                        async: true
                    })
                        .done(function (updatedData) {
                            data = updatedData;
                            controller.updateShareUrl();
                        })
                        .always(function () {
                            controller.updatePreview(true);
                        });
                    if (page.find('input#showWidgetCode').length) {
                        page.find('input#showWidgetCode').prop('checked', false);
                        page.find('input#embed-code').addClass('hidden');
                    }
                });

                page.find('input#showWidgetCode').change(function () {
                    if (this.checked) {
                        page.find('input#embed-code').removeClass('hidden');
                        page.find('input#embed-code').click();
                    } else {
                        page.find('input#embed-code').addClass('hidden');
                    }
                });

                page.find('#amp')
                    .off('click')
                    .on('click', function () {
                        controller.updatePreview(false);
                    });

                wo$(window).on('message', function (event) {
                    if (
                        event.originalEvent.data &&
                        Object.prototype.hasOwnProperty.call(event.originalEvent.data, 'sentinel') &&
                        event.originalEvent.data.sentinel === 'whistleout-widget'
                    ) {
                        page.find('#embed-preview').height(event.originalEvent.data.height);
                    }
                });
            },

            updatePreview: function (refreshWidget) {
                var amp = page.find('#amp').is(':checked');
                var embedUrl = amp ? data.embedAmpUrl : data.embedUrl;
                if (data.encode || amp) embedUrl = embedUrl.replace(/&/g, '&amp;');

                var format = amp ? data.embedAmpFormatString : data.embedFormatString;
                var code = format.replace('{url}', embedUrl);
                page.find('#embed-code').val(code).css('background-color', 'rgba(255,255,0,.3)').animate(
                    {
                        backgroundColor: 'white'
                    },
                    2000
                );

                if (refreshWidget) {
                    var previewUrl = data.previewUrl;
                    page.find('#embed-preview').attr('src', previewUrl);
                }
            },

            updateShareUrl: function () {
                page.find('#share-url').val(data.shareUrl);
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
